// extracted by mini-css-extract-plugin
export default {"competences":"GeneralView_competences__Nfhv1","fullGrade":"GeneralView_fullGrade__QYDmB","likeAnimation":"GeneralView_likeAnimation__rTyPM"};